export const MOCKED_ORGANIZATION_ID = '001VX00000JDDm5YAH';
export const DEFAULT_CURRENCY = {
  code: 'USD',
  symbol: '$',
};

export const DIALOG_QUERY_PARAM = 'dialog';
export const TOS_DIALOG_QUERY_VALUE = 'tos';
export const PHONE_MODAL_DISMISSED_KEY_PREFIX = 'phone-modal-dismissed';

export const ABOUTSIB_URL = 'https://www.aboutsib.com/';
export const PRIVACY_POLICY_URL = 'https://www.aboutsib.com/privacy/';
export const TERMS_OF_USE_URL = 'https://www.aboutsib.com/terms/';
export const SPENDBRAIN_LEARN_MORE_URL = 'https://www.aboutsib.com/spendbrain/';
export const PAYMENT_URL = 'https://vector97.com/make-a-payment/';

export const DEFAULT_DATE_FORMAT = 'dd.MM.yyyy';
export const MEDIA_SM_QUERY = '(max-width: 640px)';

export enum BadgeLocation {
  SIDE_PANEL = 'side_panel',
  LOGIN_PAGE = 'login_page',
}

export const NO_DATA_PLACEHOLDER = '-';
